export const DEFAULT_TITLE = 'BeansiD'

export const BEANS_ID_FAVICON = 'images/favicon.png'
